<script>
import { context } from "../Store/ContextStore"

export let location
export let cardStyle = 'stacked' // options = [ horizontal, stacked ]

// vars
const contextUrl = location.context_urls[$context.id] || '#'
</script>

<div
	class="card card--location card--{cardStyle}"
	data-location={location.slug}
>
	<a href={contextUrl}>

		{#if location.image_url}
			<div class="card__image">
				<img src="{location.image_url}" alt="{location.title}">
			</div>
		{/if}

		<div class="card__content">
			<div class="card__title">
				<h3 class="card__location-title">{location.title}</h3>
				{#if location.title_message}
					<div class="card__location-title-message">{location.title_message}</div>
				{/if}
				<div class="card__location-address">{location.city?.title}</div>
			</div>
		</div>

	</a>
</div>
